import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border border-gray-800 rounded-lg overflow-hidden mb-2 bg-gray-900 transition-colors hover:border-gray-700" data-id="element-51">
      <button onClick={onToggle} className="w-full flex items-center justify-between p-4 text-left focus:outline-none cursor-pointer" aria-expanded={isOpen} data-id="element-52">
        <span className="text-sm md:text-base font-bold text-white font-heading pr-3" data-id="element-53">
          {question}
        </span>
        <ChevronDownIcon className={`w-4 h-4 text-gray-500 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-yellow-400' : ''}`} data-id="element-54" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-55">
        <p className="px-4 pb-4 text-gray-400 font-body text-xs md:text-sm leading-relaxed border-t border-gray-800/50 pt-2.5" data-id="element-56">
          {answer}
        </p>
      </div>
    </div>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const faqs = [{
    q: '¿Cómo recibo el MegaPack?',
    a: 'Acceso inmediato en formato digital.'
  }, {
    q: '¿Sirve si mis padres aún son independientes?',
    a: 'Sí, es incluso el mejor momento para usarlo.'
  }, {
    q: '¿Aplica en mi país?',
    a: 'Sí, está diseñado para todo el mundo hispanohablante.'
  }, {
    q: '¿Necesito conocimientos previos?',
    a: 'No, está pensado para cualquier persona.'
  }, {
    q: '¿Cuándo veré resultados?',
    a: 'Desde los primeros días al aplicar.'
  }, {
    q: '¿Qué pasa si la situación es compleja?',
    a: 'Incluye sistemas avanzados para casos difíciles.'
  }, {
    q: '¿Y si no me funciona?',
    a: 'Tienes garantía de 7 días.'
  }];
  return <section className="w-full bg-[#111111] py-8 md:py-12 px-4 border-t border-gray-800" data-id="element-57">
      <div className="max-w-3xl mx-auto" data-id="element-58">
        <h2 className="text-2xl md:text-3xl font-black font-heading text-white text-center mb-6" data-id="element-59">
          ❓ PREGUNTAS FRECUENTES
        </h2>
        <div className="space-y-1.5" data-id="element-60">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} isOpen={openIndex === index} onToggle={() => toggle(index)} data-id="element-61" />)}
        </div>
      </div>
    </section>;
}